// importing required package and style file
import React from "react";
import "../styles/Footer.css";

function Footer() {
    return (
        <footer className="footer">
        <h6>Josh Everett</h6>
    </footer>
    )
}

// exporting component to be used in other parts of the application
export default Footer